<div class="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-6">
  <div class="max-w-7xl mx-auto">
    <!-- Header -->
    <div class="mb-8">
      <div class="flex justify-between items-center">
        <div>
          <h1 class="text-3xl font-bold text-gray-900">Unités de mesure</h1>
          <p class="text-gray-600 mt-2">Gérez les unités de mesure de votre système</p>
        </div>
        <button
          (click)="rafraichir()"
          [disabled]="loading"
          class="flex items-center gap-2 px-4 py-2.5 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 disabled:bg-gray-100 disabled:cursor-not-allowed transition-all shadow-sm hover:shadow"
        >
          <svg 
            class="w-5 h-5" 
            [class.animate-spin]="loading"
            fill="none" stroke="currentColor" viewBox="0 0 24 24"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
          </svg>
          <span class="font-medium">Rafraîchir</span>
        </button>
      </div>
    </div>

    <!-- Messages de notification -->
    <div *ngIf="error" class="mb-6 p-4 bg-red-50 border-l-4 border-red-500 text-red-700 rounded-r-lg shadow-sm animate-slideIn">
      <div class="flex items-start">
        <svg class="w-5 h-5 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/>
        </svg>
        <span class="font-medium">{{ error }}</span>
      </div>
    </div>

    <div *ngIf="successMessage" class="mb-6 p-4 bg-green-50 border-l-4 border-green-500 text-green-700 rounded-r-lg shadow-sm animate-slideIn">
      <div class="flex items-start">
        <svg class="w-5 h-5 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
        </svg>
        <span class="font-medium">{{ successMessage }}</span>
      </div>
    </div>
    
    <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
      <!-- Section Formulaire (Colonne fixe à gauche) -->
      <div class="lg:col-span-1">
        <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-6 sticky top-6">
          <div class="flex items-center justify-between mb-6">
            <h2 class="text-xl font-semibold text-gray-900">
              {{ modeEdition ? 'Modifier l\'unité' : 'Nouvelle unité' }}
            </h2>
            <div *ngIf="modeEdition" class="flex items-center gap-2 px-3 py-1 bg-orange-100 text-orange-700 rounded-full text-sm font-medium">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
              </svg>
              Édition
            </div>
          </div>
          
          <form [formGroup]="uniteForm" (ngSubmit)="onSubmit()" class="space-y-5">
            <!-- Libellé -->
            <div>
              <label for="label" class="block text-sm font-medium text-gray-700 mb-2">
                Libellé <span class="text-red-500">*</span>
              </label>
              <input
                id="label"
                type="text"
                formControlName="label"
                placeholder="Ex: Kilogramme"
                class="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-all"
                [class.border-red-500]="label?.invalid && label?.touched"
                [class.bg-gray-50]="loading"
              >
              <div *ngIf="label?.invalid && label?.touched" class="mt-2 text-sm text-red-600 flex items-start gap-1">
                <svg class="w-4 h-4 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
                </svg>
                <span *ngIf="label?.errors?.['required']">Le libellé est requis</span>
                <span *ngIf="label?.errors?.['minlength']">Le libellé doit contenir au moins 2 caractères</span>
              </div>
            </div>

            <!-- Code/Symbole -->
            <div>
              <label for="code" class="block text-sm font-medium text-gray-700 mb-2">
                Code ou symbole <span class="text-red-500">*</span>
              </label>
              <input
                id="code"
                type="text"
                formControlName="code"
                placeholder="Ex: kg"
                class="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-all"
                [class.border-red-500]="code?.invalid && code?.touched"
                [class.bg-gray-50]="loading"
              >
              <div *ngIf="code?.invalid && code?.touched" class="mt-2 text-sm text-red-600 flex items-start gap-1">
                <svg class="w-4 h-4 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
                </svg>
                <span *ngIf="code?.errors?.['required']">Le code est requis</span>
                <span *ngIf="code?.errors?.['minlength']">Le code doit contenir au moins 1 caractère</span>
              </div>
            </div>

            <!-- Options de dates -->
            <div class="space-y-3 pt-2">
              <div class="flex items-center p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors">
                <input
                  id="hasStartDate"
                  type="checkbox"
                  formControlName="hasStartDate"
                  class="h-4 w-4 text-orange-600 focus:ring-orange-500 border-gray-300 rounded cursor-pointer"
                  [disabled]="loading"
                >
                <label for="hasStartDate" class="ml-3 block text-sm text-gray-700 cursor-pointer select-none flex items-center gap-2">
                  <svg class="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                  </svg>
                  Possède une date de début
                </label>
              </div>
              
              <div class="flex items-center p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors">
                <input
                  id="hasEndDate"
                  type="checkbox"
                  formControlName="hasEndDate"
                  class="h-4 w-4 text-orange-600 focus:ring-orange-500 border-gray-300 rounded cursor-pointer"
                  [disabled]="loading"
                >
                <label for="hasEndDate" class="ml-3 block text-sm text-gray-700 cursor-pointer select-none flex items-center gap-2">
                  <svg class="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                  </svg>
                  Possède une date de fin
                </label>
              </div>
            </div>

            <!-- Boutons d'action -->
            <div class="flex gap-3 pt-4">
              <button
                type="submit"
                [disabled]="!isFormValid"
                class="flex-1 bg-orange-500 text-white py-2.5 px-6 rounded-lg font-medium hover:bg-orange-600 disabled:bg-gray-300 disabled:cursor-not-allowed transition-all shadow-sm hover:shadow-md flex items-center justify-center gap-2"
              >
                <svg *ngIf="loading" class="w-4 h-4 animate-spin" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
                </svg>
                <svg *ngIf="!loading && !modeEdition" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
                </svg>
                <svg *ngIf="!loading && modeEdition" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                </svg>
                {{ submitButtonText }}
              </button>
              
              <button
                *ngIf="modeEdition"
                type="button"
                (click)="annulerEdition()"
                [disabled]="loading"
                class="px-6 py-2.5 border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 disabled:bg-gray-100 disabled:cursor-not-allowed transition-all shadow-sm flex items-center gap-2"
              >
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
                Annuler
              </button>
            </div>
          </form>
        </div>
      </div>

      <!-- Section Liste (2 colonnes sur grand écran) -->
      <div class="lg:col-span-2">
        <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
          <!-- En-tête de la liste -->
          <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
            <div>
              <h2 class="text-xl font-semibold text-gray-900">Liste des unités</h2>
              <p class="text-sm text-gray-600 mt-1">{{ paginationInfo }}</p>
            </div>
            
            <!-- Sélecteur de taille de page -->
            <div class="flex items-center gap-3">
              <label class="text-sm font-medium text-gray-700">Afficher:</label>
              <select 
                (change)="onPageSizeChange($event)"
                [value]="pageSize"
                [disabled]="loading"
                class="border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-orange-500 focus:border-orange-500 bg-white disabled:bg-gray-100 disabled:cursor-not-allowed"
              >
                <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }} par page</option>
              </select>
            </div>
          </div>

          <!-- Indicateur de chargement -->
          <div *ngIf="loading" class="flex flex-col justify-center items-center py-16">
            <svg class="w-12 h-12 animate-spin text-orange-500 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
            </svg>
            <p class="text-gray-600 font-medium">Chargement des unités...</p>
          </div>

          <!-- Liste des unités -->
          <div *ngIf="!loading" class="space-y-3">
            <div
              *ngFor="let unite of unites; trackBy: trackByFn"
              class="group flex items-center justify-between p-4 border border-gray-200 rounded-lg hover:border-orange-300 hover:shadow-md transition-all duration-200"
              [class.bg-orange-50]="uniteEnEdition?.id === unite.id"
              [class.border-orange-400]="uniteEnEdition?.id === unite.id"
              [class.shadow-md]="uniteEnEdition?.id === unite.id"
            >
              <div class="flex-1 min-w-0">
                <div class="flex items-center gap-3">
                  <div class="flex-1 min-w-0">
                    <h3 class="font-semibold text-gray-900 truncate">{{ unite.label }}</h3>
                    <p class="text-sm text-gray-600 mt-0.5">Code: <span class="font-mono font-medium text-gray-800">{{ unite.code }}</span></p>
                  </div>
                </div>
                
                <div *ngIf="unite.hasStartDate || unite.hasEndDate" class="flex flex-wrap gap-2 mt-3">
                  <span *ngIf="unite.hasStartDate" class="inline-flex items-center gap-1 px-2.5 py-1 bg-blue-100 text-blue-700 rounded-full text-xs font-medium">
                    <svg class="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clip-rule="evenodd"></path>
                    </svg>
                    Date début
                  </span>
                  <span *ngIf="unite.hasEndDate" class="inline-flex items-center gap-1 px-2.5 py-1 bg-purple-100 text-purple-700 rounded-full text-xs font-medium">
                    <svg class="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clip-rule="evenodd"></path>
                    </svg>
                    Date fin
                  </span>
                </div>
              </div>
              
              <div class="flex items-center gap-2 ml-4">
                <!-- Bouton Modifier -->
                <button
                  (click)="commencerEdition(unite)"
                  [disabled]="loading"
                  class="p-2.5 text-orange-600 hover:bg-orange-100 rounded-lg transition-all disabled:text-gray-400 disabled:cursor-not-allowed group-hover:bg-orange-50"
                  title="Modifier cette unité"
                >
                  <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                          d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z">
                    </path>
                  </svg>
                </button>
                
                <!-- Bouton Supprimer -->
                <button
                  (click)="supprimerUnite(unite.id!)"
                  [disabled]="loading"
                  class="p-2.5 text-red-600 hover:bg-red-100 rounded-lg transition-all disabled:text-gray-400 disabled:cursor-not-allowed group-hover:bg-red-50"
                  title="Supprimer cette unité"
                >
                  <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                          d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16">
                    </path>
                  </svg>
                </button>
              </div>
            </div>
            
            <!-- Message si aucune unité -->
            <div *ngIf="unites.length === 0 && !loading" class="text-center py-16">
              <svg class="w-16 h-16 mx-auto mb-4 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                      d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4">
                </path>
              </svg>
              <p class="text-gray-600 font-medium text-lg mb-1">Aucune unité de mesure</p>
              <p class="text-gray-500 text-sm">Commencez par ajouter votre première unité</p>
            </div>
          </div>

          <!-- Pagination -->
          <div *ngIf="!loading && totalElements > 0" class="mt-6 border-t border-gray-200 pt-6">
            <!-- Contrôles de navigation -->
            <div class="flex justify-center items-center gap-1.5 flex-wrap">
              <!-- Première page -->
              <button
                (click)="changerPage(0)"
                [disabled]="isFirstPage || loading"
                class="p-2 text-sm font-medium border border-gray-300 rounded-lg hover:bg-gray-50 disabled:bg-gray-100 disabled:cursor-not-allowed disabled:text-gray-400 transition-all"
                title="Première page"
              >
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 19l-7-7 7-7m8 14l-7-7 7-7"></path>
                </svg>
              </button>

              <!-- Page précédente -->
              <button
                (click)="pagePrecedente()"
                [disabled]="isFirstPage || loading"
                class="p-2 text-sm font-medium border border-gray-300 rounded-lg hover:bg-gray-50 disabled:bg-gray-100 disabled:cursor-not-allowed disabled:text-gray-400 transition-all"
                title="Page précédente"
              >
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
                </svg>
              </button>

              <!-- Numéros de pages -->
              <div class="flex gap-1.5">
                <button
                  *ngFor="let page of pagesDisponibles"
                  (click)="changerPage(page)"
                  [disabled]="loading"
                  [class.bg-orange-500]="page === currentPage"
                  [class.text-white]="page === currentPage"
                  [class.border-orange-500]="page === currentPage"
                  [class.hover:bg-orange-600]="page === currentPage && !loading"
                  [class.hover:bg-gray-50]="page !== currentPage && !loading"
                  [class.font-bold]="page === currentPage"
                  class="min-w-[40px] h-[40px] px-3 py-2 text-sm font-medium border border-gray-300 rounded-lg transition-all disabled:cursor-not-allowed"
                >
                  {{ page + 1 }}
                </button>
              </div>

              <!-- Page suivante -->
              <button
                (click)="pageSuivante()"
                [disabled]="isLastPage || loading"
                class="p-2 text-sm font-medium border border-gray-300 rounded-lg hover:bg-gray-50 disabled:bg-gray-100 disabled:cursor-not-allowed disabled:text-gray-400 transition-all"
                title="Page suivante"
              >
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                </svg>
              </button>

              <!-- Dernière page -->
              <button
                (click)="changerPage(totalPages - 1)"
                [disabled]="isLastPage || loading"
                class="p-2 text-sm font-medium border border-gray-300 rounded-lg hover:bg-gray-50 disabled:bg-gray-100 disabled:cursor-not-allowed disabled:text-gray-400 transition-all"
                title="Dernière page"
              >
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 5l7 7-7 7M5 5l7 7-7 7"></path>
                </svg>
              </button>
            </div>

            <!-- Informations de pagination (en bas) -->
            <div class="flex justify-center mt-4">
              <p class="text-sm text-gray-600 text-center">
                Page <span class="font-semibold text-gray-900">{{ currentPage + 1 }}</span> sur 
                <span class="font-semibold text-gray-900">{{ totalPages }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>